import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/(dashboard)/admin/users/$userId/')({
  beforeLoad: ({ params, search }) => {
    const normalizedSearch = {
      name:
        search && typeof search === 'object' && 'name' in search
          ? (search.name as string | undefined)
          : undefined,
    }

    throw redirect({
      to: '/admin/users/$userId/organizations',
      params,
      search: normalizedSearch,
    })
  },
})
